import { createFileRoute } from '@tanstack/react-router'
import LancamentosPage from '@/pages/financeiro/lancamentos-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/financeiro/lancamentos',
)({
  component: function LancamentosRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.FINANCE_FULL}>
        <LancamentosPage />
      </ProtectedRoute>
    )
  },
})
